global.$ = global.jQuery = require('jquery');

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import Headroom from "headroom.js";

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
window.Swiper = Swiper;

import AOS from 'aos';
import 'aos/dist/aos.css';

$(document).ready(function() {

    // Burger toggle open/close
    const headerOverlay = $('.header__overlay');
    const closerX = $('#closerX-box');
    // sticky scroll menu
    const header = $('header');
    let offSet = $('.home-background-video').innerHeight()
    let fromTop = ($(window).scrollTop())
    let beforeAfterImg =$('.box-before-after .img');
    beforeAfterImg.css('background-size' , $(".box-before-after").width()+'px')
    window.onresize = function() {
        offSet = $('.home-background-video').innerHeight()
        beforeAfterImg.css('background-size' , $(".box-before-after").width()+'px')
        setHead()
    }
    setHead()
    function setHead(){
            header.removeClass('header--std');
            if (header.attr('data-type') === 'header--home') {
                if (fromTop >= offSet){
                    header.removeClass(header.attr('data-type'));
                } else {
                    header.addClass(header.attr('data-type'));
                }
                window.onscroll = function () {
                    fromTop = ($(window).scrollTop())
                    if (fromTop >= offSet){
                        header.removeClass(header.attr('data-type'));
                        header.addClass('header--std');
                    } else {
                        header.addClass(header.attr('data-type'));
                        header.removeClass('header--std');
                    }
                };
            } else {
                header.addClass('header--std');
            }
        }

    if($('.headroom').length > 0){
        let headroomEl = document.querySelector("header");
        let options = {
            offset : 100,
        }
        let headroom  = new Headroom(headroomEl,options);
        headroom.init();
    }

    headerOverlay.click(function (e) {
        toggleMenuOpenClose();
    })

    closerX.click(function (e) {
        toggleMenuOpenClose();
    })

    // burger menu effect button
    let burgerButton = $('.burger-button');
    burgerButton.on('click', function(e) {
        e.preventDefault();
        toggleMenuOpenClose();
    });

    function toggleMenuOpenClose() {
        let body = $('body');
        let headerNavWrapper = $('.header__nav-wrapper');
        if (headerNavWrapper.hasClass('open')) {
            body.removeClass('no-scroll-y');
            headerNavWrapper.removeClass('open');
            headerOverlay.removeClass('open');
        } else {
            body.addClass('no-scroll-y');
            headerNavWrapper.addClass('open');
            headerOverlay.addClass('open');
        }
        $('#burger-button i').toggleClass("fa-bars fa-x");
    }

    // To-top button
    const toTopBtn = $('#to-top');
    $(window).scroll(function(){
        if ($(window).scrollTop() > 300) {
            toTopBtn.fadeIn();
        } else {
            toTopBtn.fadeOut();
        }
    });

    toTopBtn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 'slow');
    });


    //creazione effetto select in referenze

    let liCategory = $('.li-category');
    let orLine = $('.or-line');
    let iconDown = $('.bi-chevron-down');
    let iconUp = $('.bi-chevron-up');
    // let liDynamic= $('.li-dynamic');

    if (window.innerWidth < 992){

        $('.default-div').on('click', function (){
            if (liCategory.hasClass('d-none')){

                liCategory.removeClass('d-none');
                liCategory.addClass('d-block');

                iconDown.addClass('d-none')
                iconUp.removeClass('d-none');
                iconUp.addClass('d-inline')


                orLine.removeClass('d-none');
                orLine.addClass('d-block');
            }else {
                liCategory.removeClass('d-block');
                liCategory.addClass('d-none');

                iconDown.removeClass('d-none');
                iconDown.addClass('d-inline');
                iconUp.removeClass('d-inline');
                iconUp.addClass('d-none');

                orLine.removeClass('d-flex');
                orLine.addClass('d-none');
            }

            // liCategory.on('click', function() {
            //     let valueCategory = $(this).text();
            //     liDynamic.html(valueCategory);
            //     $(this).addClass();
            // });
        })
    }

    $("#slider").on("input change", (e)=>{
        const sliderPos = e.target.value;
        // Update the width of the foreground image
        $('.foreground-img').css('width', `${sliderPos}%`)
        // $('.background-img').css('width', `${sliderPos}%`)
        // Update the position of the slider button
        $('.slider-button').css('left', `calc(${sliderPos}% - 16px)`)
        $('.slider-bar').css('left', `${sliderPos}%`)
    });

    $(function() {
        AOS.init({
            duration: 600,
            //offset: 50,
            mirror: true,
            once: true,
        });
    });

    $('.accordion-collapse').on('shown.bs.collapse', function (e) {
        let $panel = $(this).closest('.accordion-item');
        $('html,body').animate({
            scrollTop: $panel.offset().top - 100
        }, 200);
    });
});
